import { useMemo } from "react";
import { usePlatform } from "@/hooks/usePlatform";
import { getPlatformConfig } from "@/lib/platform/config";
import { resolveBrandContent } from "@/lib/runtime-brand-copy.mjs";

/** Only first-party editorial records; never pass customer-authored records. */
export function useRuntimeBrandContent<T>(content: T): T {
  const { name } = usePlatform();
  const legacyName = getPlatformConfig("bac").name;
  return useMemo(() => resolveBrandContent(content, name, legacyName), [content, name, legacyName]);
}
